import { Variant } from '../../../wp-blocks/button/resurs-button';

export function Icon({ variant }: { variant: Variant }) {
    if (variant === 'standard') {
        return null;
    }

    if (variant === 'arrow') {
        return (
            <span className="r-w-[25px]">
                <svg
                    className="css-16j8fa2-StyledSvg-StyledSvg-getVariant e1vusaav0"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 75 50"
                    fill="currentColor"
                >
                    <g id='Resurs-Bank-Icons-"The-Dot"-Updated' stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="RB-icons-Light-BG-Dark-Icons" transform="translate(-139.000000, -1178.000000)">
                            <g id="arrow-right" transform="translate(139.000000, 1178.000000)">
                                <rect id="Rectangle-Copy-16" opacity="0" x="0" y="0" width="70" height="40"></rect>
                                <g
                                    id="Group-9"
                                    transform="translate(35.000000, 20.000000) scale(-1, 1) translate(-35.000000, -20.000000) "
                                    fill="white"
                                    fillRule="nonzero"
                                >
                                    <path
                                        d="M22.8284271,1.17157288 C24.3384544,2.68160014 24.3887886,5.09856437 22.9794299,6.66905409 L22.8284271,6.82842712 L13.656,16 L66,16 C68.209139,16 70,17.790861 70,20 C70,22.1421954 68.3160315,23.8910789 66.1996403,23.9951047 L66,24 L13.657,24 L22.8284271,33.1715729 C24.3905243,34.73367 24.3905243,37.26633 22.8284271,38.8284271 C21.3183999,40.3384544 18.9014356,40.3887886 17.3309459,38.9794299 L17.1715729,38.8284271 L1.17157288,22.8284271 L1.13295457,22.7892776 C1.11241903,22.7681731 1.09211452,22.7468427 1.07204512,22.7252904 L1.17157288,22.8284271 C1.10915172,22.766006 1.04922491,22.702035 0.991792437,22.6366382 C0.978614223,22.621473 0.965477421,22.6062687 0.952453848,22.5909651 C0.855739917,22.4776615 0.766467605,22.3601438 0.684547799,22.2391341 C0.671073385,22.2186091 0.657659022,22.1983894 0.644424715,22.1780419 C0.559210211,22.0470533 0.486735276,21.9200409 0.421766235,21.7902303 L0.393835694,21.7329036 C0.378674706,21.7014111 0.363914097,21.6696895 0.34956047,21.6377455 C0.337555099,21.6111876 0.326101407,21.5848759 0.314944158,21.5584687 C0.298704797,21.5200658 0.282915887,21.4810799 0.267729381,21.4417941 C0.261216806,21.4246961 0.254794333,21.4076957 0.248491751,21.3906609 C0.230012887,21.3411681 0.212595478,21.291167 0.196153471,21.2407253 C0.191822484,21.2266841 0.187243724,21.2123365 0.182747916,21.1979685 C0.128974571,21.0272223 0.0866741063,20.8519502 0.0563087853,20.6726185 C0.0304246401,20.5181437 0.0133271379,20.3625973 0.00530958889,20.2066711 C0.00176344485,20.1382328 0,20.0693223 0,20 C0,19.8445181 0.00887106179,19.6911081 0.0261346553,19.5402486 C0.0387914352,19.4321188 0.0556191597,19.3244887 0.076843563,19.2175582 C0.132228916,18.9367269 0.217112092,18.667055 0.327944453,18.4112403 C0.368214514,18.317928 0.412534393,18.2253178 0.460618981,18.1341742 C0.472948592,18.1113944 0.485180991,18.0887734 0.497623689,18.066285 C0.518334482,18.0281981 0.540009752,17.9904558 0.562350689,17.9530001 C0.573853688,17.9343912 0.584998082,17.9160575 0.59628494,17.8978214 C0.616282455,17.8648304 0.637379875,17.8318227 0.659009742,17.7990632 C0.676481325,17.773231 0.693829804,17.7476039 0.711465288,17.722191 C0.734380542,17.6886119 0.758061919,17.6555933 0.782306837,17.6228608 C0.79491987,17.6062916 0.807761653,17.5892197 0.820736151,17.5722546 C0.849138072,17.5347489 0.878167525,17.4981782 0.907928635,17.4620076 C0.917793555,17.4502724 0.927866428,17.438158 0.938009169,17.4261044 C0.964940231,17.3939194 0.992464947,17.3622644 1.02057015,17.3309459 L1.17157288,17.1715729 L17.1715729,1.17157288 C18.73367,-0.390524292 21.26633,-0.390524292 22.8284271,1.17157288 Z"
                                        id="Combined-Shape"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </span>
        );
    }

    if (variant === 'bankidwhite') {
        return (
            <span className="r-w-[25px]" aria-hidden="true">
                <img src="/assets/icons/bankid-se.svg" alt="" />
            </span>
        );
    }

    if (variant === 'bankidnorwaypurple' || variant === 'bankidnorwaywhite') {
        const src = variant === 'bankidnorwaywhite' ? 'bankid_logo_norway_white.svg' : 'bankid_logo_norway_purple.svg';
        return (
            <span className="r-w-[85px]" aria-hidden="true">
                <img src={`/assets/icons/${src}`} alt="" />
            </span>
        );
    }

    return null;
}
